import Config from '@skin_config';
import { changeSecondScreen } from '@common/helpers/secondScreen';

class PascalHandler {
  openStream(streamUrl) {
    changeSecondScreen(Config, { command: 'ThirdParty', id: 111, url: streamUrl, providerId: 21 });
  }

  onIframeMessage({ data }) {
    if (typeof data !== 'object') return;

    if (data.type === 'openStream') this.openStream(data.payload.url);
  }
}

export default PascalHandler;
